import { Button } from "components/Button"
import { cdn } from "core/cdn"
import { useLanguage } from "locales"

import { GenericModal } from "./Modal"

interface RemoveFamilyDoctorModalProps {
  visible: boolean
  loading: boolean
  // Already localized, varies for the account holder and for a relative
  text: string
  onAccept: () => void
  onCancel: () => void
}

// Confirmation shown when the patient says they no longer have a treating
// doctor: closing cross at the top right, warning picto, explanation, then
// a destructive primary action above a secondary cancel action.
export const RemoveFamilyDoctorModal: React.FC<RemoveFamilyDoctorModalProps> = (
  props
): JSX.Element => {
  const { languages } = useLanguage()
  const cancel = () => {
    if (!props.loading) props.onCancel()
  }
  return (
    <GenericModal
      visible={props.visible}
      noFooter
      style={{ width: 1100 }}
      bodyStyle={{ padding: 25 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 40,
        }}
      >
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          {/* Padding enlarges the touch target around the 22px cross without moving it */}
          <div
            onClick={cancel}
            style={{ padding: 20, margin: -20, cursor: "pointer", lineHeight: 0 }}
            data-testid="remove-family-doctor-close"
          >
            <img src={cdn("/images/close_pop-up.svg")} alt={languages.close} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 24,
          }}
        >
          <img
            src={cdn("/images/attention_picto_red.svg")}
            width={120}
            height={120}
            alt=""
          />
          <p
            style={{
              fontSize: 28,
              textAlign: "center",
              maxWidth: 1000,
              margin: 0,
            }}
          >
            {props.text}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 24,
          }}
        >
          <Button
            htmlType="button"
            type="primary"
            danger
            loading={props.loading}
            onClick={props.onAccept}
            style={{ width: 700 }}
          >
            {languages.removeFamilyDoctorAccept}
          </Button>
          <Button
            htmlType="button"
            disabled={props.loading}
            onClick={cancel}
            style={{ width: 700, color: "#1d71b8", borderColor: "#1d71b8", background: "#fff" }}
          >
            {languages.cancel}
          </Button>
        </div>
      </div>
    </GenericModal>
  )
}
